import React, { useState, useEffect, useContext, useRef } from 'react';
import resourcesServices from '../services/resourcesServices';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import { errorClassification } from '../errorHandler';
import MessageModal from '../container/MessageModal';

const AccesosNginx = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [accesos, setAccesos] = useState([]);
  const [archivos, setArchivos] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {

    if(authInformation.autenticado === true){
      if( authInformation.rol === 'Admin' ){
        setRenderHTML(true)
        obtenerAccesos();
        //obtenerArchivos();
      } else {
        navigate(`/`);
      }
    } else{
      setRenderHTML(false)
    }
  }, [authInformation]);


  const obtenerAccesos = async (archivo='access.log') => {
    try {
      const data = await resourcesServices.obtenerResources('status', '', '', '', 'file='+archivo);

      setAccesos(data.data)

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const obtenerArchivos = async (sortBy='') => {
    try {
      const data = await resourcesServices.obtenerResources('status/accessFiles');

      setArchivos(data.data)

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const listarAccesos = accesos && accesos.map((acceso, idx) => {

    return (
          <>
            <tr className='text-start' key={idx}>
              <td className=''>{acceso.ip}</td>
              <td>{acceso.date}</td>
              <td>{acceso.access}</td>
            </tr>
            <tr className='text-start' key={idx}>
              <td className='border-bottom border-3' colspan="3">{acceso.agent}</td>
            </tr>
          </>
          )
  })



  return (
    <>
      {renderHTML && (
        <>
          <h1>Accesos a Nginx</h1>
          <div className="container">
            <div className="btn-group" role="group">
              <button className='btn btn-primary' type='button' onClick={()=>obtenerAccesos('access.log')}>access.log</button>
              <button className='btn btn-secondary' type='button' onClick={()=>obtenerAccesos('access.log.1')}>access.log.1</button>
            </div>
            <div className="mb-3">

            <table className="table table-bordered table-sm mb-5">
              <thead>
                <tr>
                  <th className="text-start" scope="col">IP</th>
                  <th className="text-start" scope="col">Fecha</th>
                  <th className="text-start" scope="col">Acceso</th>
                </tr>
              </thead>
              <tbody>
                {listarAccesos}
              </tbody>
            </table>
            </div>
          </div>
        </>
      )}

      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
      />
    </>
  );
};

export default AccesosNginx;